define('features/overlayGameLauncher/adventureTwo/inventory/inventoryInit',[],function () {

    return function AdventureTwoInventoryInit (adventurers,
                                              adventureTwoObservableData) {
        var self = this;

        self.init = function (player) {
            var inventory = adventurers.getByPlayerId(player.id).getAdventure().freshEarnedItems;

            adventureTwoObservableData.property('inventory')(inventory);
        };
    };

});

